"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useDataLinkTableInstance(selector) {
  const {
    item: dataLinkTableInstance,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.DataLinkTableInstance,
    selector,
    (integrationApp) => selector ? integrationApp.dataLinkTableInstance(selector) : void 0
  );
  return {
    dataLinkTableInstance,
    accessor,
    refresh,
    findLinks: accessor?.findLinks,
    createLink: accessor?.createLink,
    deleteLink: accessor?.deleteLink,
    ...rest
  };
}

export { useDataLinkTableInstance };
